<template>
    <div>
        <v-form ref="form" class="p-2">
           <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">  
                    <v-file-input 
                        v-model="file"
                        :rules="[rules.required]"
                        :accept="localItem.extensions"
                        show-size 
                        counter 
                        :label="localItem.label_extensions"
                        outlined
                        dense
                        clearable
                        :class="$css_field"
                        :multiple="localItem.multiple"
                        :prepend-icon="localItem.icon ? localItem.icon : 'mdi-paperclip'"
                    ></v-file-input>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
                    <v-btn
                        color="primary"
                        @click="validate"
                        :class="$css_button"
                        :block="$vuetify.breakpoint.smAndDown"
                    >
                        Adicionar
                    </v-btn>
                </v-col> 
                
            </v-row>
        </v-form> 

            <v-row v-if="localItem.items">
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">  
                    <v-card
                        class="mx-auto"
                        outlined
                    >
                        <v-data-table
                            :headers="headers"
                            :items="localItem.items"
                            :items-per-page="10"
                            sort-by="id"
                            class="elevation-1 table-striped"
                        >
                            <template v-slot:[`item.description`]="{ item }">
                                <span :class="$css_report_list">
                                    {{ item.description }}
                                    <span class="ml-2" v-if="item.description_medium">({{ item.description_medium }})</span>
                                </span> 
                            </template>
  
                            <template v-slot:[`item.photo`]="{ item }">
                                <v-avatar
                                    tile
                                    width="100px"
                                    height="80px"
                                >
                                    <v-img 
                                        v-if="item.file && item.file != ''"
                                        :src="item | urlUpload"
                                        :lazy-src="item | urlUpload"
                                    >
                                        <template v-slot:placeholder>
                                            <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                            >
                                            <v-progress-circular
                                                indeterminate
                                                color="grey lighten-5"
                                            ></v-progress-circular>
                                            </v-row>
                                        </template>
                                    </v-img>
                                </v-avatar>     
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-card-actions>
                                    <v-tooltip left v-if="item.file">
                                        <template v-slot:activator="{ on, attrs }">
                                            <a :href="item | urlUpload" target="_blank">  
                                                <v-icon v-bind="attrs" v-on="on">mdi-download</v-icon>                           
                                            </a>
                                        </template>
                                        <span>DOWNLOAD</span>
                                    </v-tooltip>   

                                    <v-tooltip left>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon @click.prevent="fileDestroy(item)" class="ml-8">
                                                <v-icon v-bind="attrs" v-on="on">mdi-delete</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>EXCLUIR</span>
                                    </v-tooltip>
                                </v-card-actions>     
                            </template>

                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
    </div>
</template>

<script>
    export default {
        props: {
            object: {
                require: true,
            },
        },

        watch: {
            object: {
                handler() {
                    this.setObject();           // ← configura o formulário com os dados
                },
                immediate: true // ← garante que execute mesmo se já estiver definido
            },
        },  

        data () {
            return {
                localItem: {},
                file: {},
                description: '',
                description_medium: '',
                description_medium2: '',

                rules: {
                    required: value => !!value || 'Required.',
                },
                headers: [
                    { text: 'DESCRIÇĀO', align: 'start', value: 'description', },
                    { text: 'AÇÕES', value: 'actions', sortable: false },
                ],
            }
        },

        methods:{   
            setObject(){
                this.localItem = this.object
            },

            changeStep(step){
                this.$emit('callChangeStep',step)
            },

            validate () {
                if (this.$refs.form.validate()) {                   
                    this.fileSubmit()
                }
            },
            
            fileSubmit(){
                const formData = new FormData()
                formData.append('model', this.localItem.model)  
                formData.append('item_id', this.localItem.item_id)  
                
                if(this.localItem.description != undefined){
                    formData.append('description', this.localItem.description)     
                }
                if(this.description != undefined && this.description != ''){
                    formData.append('description', this.description)     
                }
                if(this.description_medium != undefined && this.description_medium != ''){
                    formData.append('description_medium', this.description_medium)     
                }
                if(this.description_medium2 != undefined && this.description_medium2 != ''){
                    formData.append('description_medium2', this.description_medium2)     
                }
               
                //formData.append('file', this.file) 
                if(Array.isArray(this.file)){
                    for( var i = 0; i < this.file.length; i++ ){
                        let file = this.file[i];
                        formData.append('file[' + i + ']', file)
                    }
                }else{
                    formData.append('file[0]', this.file)
                }  
            
                this.$store.dispatch('storeUpload', formData)
                            .then(response => {
                                this.loadPromisseUploads()
                                this.reset()
                                this.$snotify.success('Upload realizado com sucesso!')
                            })
                            .catch(error => {   
                                this.$snotify.error('Erro no cadastro')
                                this.errors = error.response.data.errors
                            })
            },
            
            loadPromisseUploads(){
                const params = {};
                params.item_id = this.localItem.item_id;
                params.model = this.localItem.model;
                
                this.$store.dispatch('loadPromisseUploads', params)
                            .then(response => {
                                this.localItem.items = response;
                            })
                            .catch(error => {
                                console.log('Erro load uploads');
                            });
            },

            reset(){
                this.$refs.form.reset()
                //this.file.description = null
                //this.file = {}
            },

            confirmDestroy(file) {
                this.$snotify.error(`Are you sure to delete this file? ${file.description}`, 'Confirmation', {
                    id: 1,
                    timeout: 10000,
                    showProgressBar: true,
                    closeOnClick: false,
                    buttons: [
                        {text: 'No', action: null},
                        {text: 'Yes', action: () => { 
                            this.fileDestroy(file)
                            //this.$snotify.remove()
                        }},
                    ] 
                })
            },

             fileDestroy(file){
                this.$store.dispatch('destroyUpload', file.id)
                            .then(response => {
                                this.loadPromisseUploads()
                            })
                            .catch(error => {
                                this.$snotify.error('Erro no cadastro')
                                this.errors = error.response.data.errors
                            })
                            .finally(
                                //this.$snotify.remove()
                                this.$snotify.success('Registro excluído com sucesso!')
                            )
            },
        }    
    }
</script>

<style scoped>
    .panel-footer {
        position: absolute;
        padding: 0%;
        margin: 0%;
        margin-top: 0px;
        z-index: 1000;
    }
</style>